export const common = {
  // Navigation
  "nav.home": "Accueil",
  "nav.categories": "Catégories",
  "nav.about": "À propos",
  "nav.contact": "Contact",
  "nav.help": "Aide",
  "nav.faq": "FAQ",
  "nav.privacy": "Confidentialité",
  "nav.terms": "Conditions",
  "nav.login": "Connexion",
  "nav.register": "Inscription",
  "nav.dashboard": "Tableau de bord",
  "nav.profile": "Profil",
  "nav.logout": "Déconnexion",
  "nav.search": "Recherche",
  "nav.suppliers": "Fournisseurs",
  "nav.products": "Produits",
  "nav.admin": "Panneau Admin",

  // Common buttons
  "btn.search": "Rechercher",
  "btn.filter": "Filtrer",
  "btn.reset": "Réinitialiser",
  "btn.submit": "Soumettre",
  "btn.cancel": "Annuler",
  "btn.save": "Enregistrer",
  "btn.edit": "Modifier",
  "btn.delete": "Supprimer",
  "btn.view": "Voir",
  "btn.contact": "Contacter",
  "btn.call": "Appeler",
  "btn.email": "Email",
  "btn.website": "Site web",
  "btn.directions": "Obtenir l'itinéraire",
  "btn.back": "Retour",
  "btn.next": "Suivant",
  "btn.previous": "Précédent",
  "btn.close": "Fermer",
  "btn.open": "Ouvrir",
  "btn.show_more": "Voir plus",
  "btn.show_less": "Voir moins",
  "btn.yes": "Oui",
  "btn.no": "Non",

  // Common labels
  "label.name": "Nom",
  "label.email": "Email",
  "label.phone": "Téléphone",
  "label.address": "Adresse",
  "label.city": "Ville",
  "label.state": "État",
  "label.country": "Pays",
  "label.description": "Description",
  "label.category": "Catégorie",
  "label.rating": "Note",
  "label.reviews": "Avis",
  "label.distance": "Distance",
  "label.location": "Emplacement",
  "label.price": "Prix",
  "label.date": "Date",
  "label.time": "Heure",
  "label.status": "Statut",
  "label.type": "Type",
  "label.language": "Langue",

  "nav.purchase_request": "Demande d'achat",
  "nav.navigation": "Navigation",
  "nav.more": "Plus",
  "nav.account": "Compte",
  "common.clear_input": "Effacer le champ",
  "common.return_home": "Retour à l'accueil",
  "common.ok": "OK",
  "common.error": "Erreur",

  // Language selector accessibility
  "common.select_language": "Sélectionner la langue",
  "common.available_languages": "Langues disponibles",
  "common.current_language": "Langue actuelle",

  // Status
  "status.active": "Actif",
  "status.inactive": "Inactif",
  "status.pending": "En attente",
  "status.approved": "Approuvé",
  "status.rejected": "Rejeté",
  "status.verified": "Vérifié",
  "status.unverified": "Non vérifié",

  // Messages
  "msg.loading": "Chargement...",
  "msg.no_results": "Aucun résultat trouvé",
  "msg.error": "Une erreur s'est produite",
  "msg.success": "Succès",
  "msg.saved": "Enregistré avec succès",
  "msg.deleted": "Supprimé avec succès",
  "msg.updated": "Mis à jour avec succès",
  "msg.created": "Créé avec succès",
  "msg.no_description": "Aucune description disponible",

  // Distance units
  "distance.km": "km",
  "distance.miles": "miles",
  "distance.nearby": "À proximité",
  "distance.within": "Dans un rayon de",

  // Time
  "time.now": "Maintenant",
  "time.today": "Aujourd'hui",
  "time.yesterday": "Hier",
  "time.week": "Cette semaine",
  "time.month": "Ce mois",
  "time.year": "Cette année",

  // Devise
  "currency.symbol": "₦",
  "currency.code": "NGN",
  "currency.name": "Naira nigérian",

  // Footer
  "footer.rights": "Tous droits réservés",
  "footer.powered_by": "Propulsé par Readdy",
  "footer.quick_links": "Liens rapides",
  "footer.support": "Support",
  "footer.follow_us": "Suivez-nous",
  "footer.description": "Le moteur de recherche géolocalisé de référence pour tous les fournisseurs du Nigeria.",
  "footer.contact": "Contact",
  "footer.about": "À propos",

  // Pages
  "page.about": "À propos",
  "page.contact": "Contact",
  "page.faq": "FAQ",
  "page.help": "Aide",
  "page.privacy": "Confidentialité",
  "page.categories": "Catégories",
  "page.supplier": "Fournisseur",
  "page.admin": "Admin",

  // Location picker
  "location.country": "Pays",
  "location.state_department": "État/Département",
  "location.city": "Ville",
  "location.address": "Adresse",
  "location.exact_location": "Localisation exacte",
  "location.select_country": "Sélectionnez un pays",
  "location.select_state": "Sélectionnez un état/département",
  "location.city_placeholder": "Entrez le nom de la ville",
  "location.address_placeholder": "Entrez l'adresse",
  "location.select_country_state_first": "Veuillez d'abord sélectionner un pays et un état",
  "location.select_on_map": "Sélectionner sur la carte",
  "location.location_selected": "Localisation sélectionnée",
  "location.select_exact_location": "Sélectionner la localisation exacte",
  "location.selected_coordinates": "Coordonnées sélectionnées",
  "location.map_instructions": "Cliquez sur la carte pour définir votre localisation exacte, ou entrez les coordonnées manuellement ci-dessous.",
  "location.manual_coords": "Coordonnées manuelles (optionnel)",
  "location.latitude": "Latitude",
  "location.longitude": "Longitude",
  "location.confirm_location": "Confirmer la localisation",
  "location.coords": "Coordonnées : {{lat}}, {{lng}}",

  // Map view
  "map.suppliers_found": "{{count}} fournisseurs trouvés",
  "map.more_suppliers": "fournisseurs de plus",
  "map.exact_location": "Localisation exacte",
  "map.approximate_location": "Localisation approximative",
  "map.approximate": "approximatif",
  "map.expand": "Agrandir la carte",
  "map.full_map_view": "Vue Carte Complète",
  "map.suppliers": "fournisseurs",

  // DeepL Translation
  "translation.view_original": "Voir l'original",
  "translation.view_translation": "Voir la traduction",
  "translation.translated_by": "Traduit par DeepL",
  "translation.translated_from": "Traduit du",
  "translation.loading": "Traduction en cours...",
  
  // Read more / Show less
  "common.read_more": "Lire la suite",
  "common.show_less": "Réduire",
  "common.translated_from_english": "Traduit de l'anglais",
  
  // Search translation (Alibaba-style)
  "search.translating": "Traduction...",
  "search.translated_from": "Traduit depuis",

  // Bug report
  "bug_report.title": "Signaler un bug",
  "bug_report.description": "Aidez-nous à améliorer l'application",
  "bug_report.label": "Décrivez le problème rencontré",
  "bug_report.placeholder": "Ex: Le bouton de recherche ne fonctionne pas sur la page...",
  "bug_report.note": "Cela ouvrira votre client email avec le rapport pré-rempli.",
  "bug_report.sending": "Envoi...",
  "bug_report.send": "Envoyer le rapport",
  "bug_report.success_title": "Merci !",
  "bug_report.success_message": "Votre rapport a été envoyé. Nous l'examinerons rapidement.",
  "bug_report.button": "Signaler un bug",

  // Quantity units
  "units.pieces": "Pièces",
  "units.kg": "Kilogrammes",
  "units.tonnes": "Tonnes",
  "units.litres": "Litres",
  "units.meters": "Mètres",
  "units.units": "Unités",
  "units.boxes": "Cartons",
  "units.pallets": "Palettes",
  "units.containers": "Conteneurs",

  // Purchase request form
  "purchase_request.title": "Publiez une demande d'achat",
  "purchase_request.subtitle": "Recevez rapidement des propositions de fournisseurs qualifiés.",
  "purchase_request.form_header": "Remplissez le formulaire ci-dessous et obtenez des offres des meilleurs fournisseurs",
  "purchase_request.description": "Description du besoin",
  "purchase_request.description_placeholder": "Ex: Machine pure water",
  "purchase_request.attachment": "Vidéo, image ou document descriptif du produit (optionnel)",
  "purchase_request.attachment_desc": "Joignez une vidéo descriptive du produit (MP4, WebM, MOV), une image (JPG, PNG) ou un document (PDF, Word)",
  "purchase_request.quantity": "Quantité",
  "purchase_request.whatsapp": "Numéro WhatsApp",
  "purchase_request.whatsapp_placeholder": "+225 071486XXXX",
  "purchase_request.submit": "Envoyer ma demande",
  "purchase_request.publishing": "Envoi en cours...",
  "purchase_request.footer": "Vous serez contacté rapidement par des fournisseurs",
  "purchase_request.errors.description_required": "La description est requise",
  "purchase_request.errors.quantity_invalid": "La quantité doit être supérieure à 0",
  "purchase_request.errors.whatsapp_required": "Le numéro WhatsApp est requis",
  "purchase_request.errors.submission": "Une erreur est survenue. Veuillez réessayer.",
  "purchase_request.success_title": "Demande publiée avec succès !",
  "purchase_request.success_message": "Votre demande a été envoyée à nos fournisseurs qualifiés. Vous recevrez rapidement des propositions adaptées à vos besoins.",
  "purchase_request.next_steps": "Prochaines étapes :",
  "purchase_request.step1": "Les fournisseurs vont étudier votre demande",
  "purchase_request.step2": "Vous recevrez des propositions par email",
  "purchase_request.step3": "Comparez et choisissez la meilleure offre",
  "purchase_request.processing_option": "Option de traitement",
  "purchase_request.processing_normal": "Normal",
  "purchase_request.processing_normal_desc": "Traitement sous 1 à 2 semaines — Gratuit",
  "purchase_request.processing_xpress": "Xpress",
  "purchase_request.processing_xpress_desc": "Traitement prioritaire sous 48-72h — 15 000 FCFA",
  "purchase_request.processing_xpress_price": "15 000 FCFA",
  "purchase_request.processing_xpress_soon": "Bientôt disponible",
  "purchase_request.email_label": "Adresse email (paiement Xpress)",
  "purchase_request.email_placeholder": "vous@exemple.com",
  "purchase_request.errors.email_required": "L'adresse email est requise pour le paiement Xpress",
  "purchase_request.errors.email_invalid": "Adresse email invalide",
  "purchase_request.errors.xpress_init_failed": "Impossible d'initialiser le paiement Xpress. Vos données sont conservées — veuillez réessayer.",
  "purchase_request.xpress_pending_note": "Votre demande est publiée en mode Normal. Activez le Xpress pour un traitement prioritaire sous 48-72h.",
  "purchase_request.xpress_unavailable_note": "Le paiement Xpress est momentanément indisponible. Votre demande reste publiée en mode Normal (1 à 2 semaines).",
  "purchase_request.activate_xpress": "Activer le Xpress maintenant — 15 000 FCFA",
  "purchase_request.success_normal": "Votre demande sera traitée sous 1 à 2 semaines.",
  "purchase_request.request_number": "N° de votre demande",
  "purchase_request.request_number_hint": "Conservez ce numéro pour suivre votre demande depuis votre tableau de bord.",
  "purchase_request.success_xpress": "Votre demande Xpress sera traitée en priorité sous 48-72h.",

  // Notifications (page /notifications, liens du dropdown)
  "notifications.page_title": "Notifications",
  "notifications.page_subtitle": "Toutes vos notifications, les plus récentes d'abord.",
  "notifications.mark_all_read": "Tout marquer comme lu",
  "notifications.load_more": "Charger plus",
  "notifications.empty_title": "Aucune notification",
  "notifications.empty_message": "Vos notifications apparaîtront ici : nouveaux messages, devis, mises à jour de vos demandes.",
  "notifications.back_dashboard": "Retour au tableau de bord",
  "notifications.view_details": "Voir le détail",
  "notifications.unread_count": "{{count}} non lue(s)",
  "notifications.just_now": "À l'instant",
  "notifications.minutes_ago": "Il y a {{count}} min",
  "notifications.hours_ago": "Il y a {{count}} h",
  "notifications.yesterday": "Hier",
  "notifications.days_ago": "Il y a {{count}} jours",
  "notifications.title": "Notifications",
  "notifications.none_unread": "Aucune notification non lue",
  "notifications.view_all": "Voir toutes les notifications",
  "notifications.dropdown_empty": "Vous n'avez pas encore de notifications",

  // Désinscription newsletter (page /newsletter/unsubscribe)
  "newsletter_unsubscribe.title": "Désinscription de la newsletter",
  "newsletter_unsubscribe.description": "Confirmez la désinscription : vous ne recevrez plus les envois Suji.",
  "newsletter_unsubscribe.email_label": "Votre adresse email",
  "newsletter_unsubscribe.submit": "Se désabonner",
  "newsletter_unsubscribe.processing_title": "Désinscription en cours...",
  "newsletter_unsubscribe.success_title": "Désinscription confirmée",
  "newsletter_unsubscribe.success_message": "Vous ne recevrez plus nos emails. À bientôt sur Suji !",
  "newsletter_unsubscribe.not_found_title": "Adresse introuvable",
  "newsletter_unsubscribe.not_found_message": "Cette adresse n'est pas inscrite à la newsletter — rien à désabonner.",
  "newsletter_unsubscribe.error_title": "Une erreur est survenue",
  "newsletter_unsubscribe.error_message": "La désinscription a échoué. Veuillez réessayer dans un instant.",
  "newsletter_unsubscribe.invalid_email": "Adresse email invalide",

  // Résultat de paiement (pages /payment/success et /payment/failed)
  "payment.checking_title": "Vérification du paiement...",
  "payment.checking_desc": "Nous confirmons votre paiement auprès de notre prestataire. Cela ne prend que quelques secondes.",
  "payment.success_title": "Paiement confirmé !",
  "payment.success_xpress": "Votre demande d'achat est passée en Xpress : traitement prioritaire sous 48-72h.",
  "payment.success_subscription": "Votre abonnement est actif. Bonne visibilité sur la plateforme !",
  "payment.success_featured": "Votre Vitrine est active : votre profil est mis en avant pendant 30 jours.",
  "payment.success_generic": "Votre paiement a été confirmé avec succès.",
  "payment.xpress_success_title": "Demande publiée avec succès !",
  "payment.xpress_success_message": "Votre demande a été enregistrée et sera traitée en priorité : vous recevrez des propositions de fournisseurs sous 72 heures ouvrées.",
  "payment.xpress_success_steps": "Prochaines étapes :",
  "payment.xpress_success_step1": "Vous recevrez des propositions de fournisseurs par email et WhatsApp sous 72 heures ouvrées.",
  "payment.xpress_success_step2": "Notre équipe SUJI vous accompagne pour comparer les offres et choisir le meilleur fournisseur.",
  "payment.xpress_cancelled_title": "Paiement annulé",
  "payment.xpress_cancelled_message": "Votre demande a tout de même été enregistrée en mode Normal (traitement sous 1 à 2 semaines). Vous pouvez réessayer le Xpress pour cette même demande afin de bénéficier du traitement prioritaire sous 72 heures ouvrées.",
  "payment.xpress_retry": "Réessayer le Xpress — 15 000 FCFA",
  "payment.xpress_retrying": "Redirection vers le paiement...",
  "payment.back_to_form": "Retourner au formulaire",
  "payment.pending_title": "Paiement en cours de traitement",
  "payment.pending_desc": "Votre paiement n'est pas encore confirmé. Si vous venez de le terminer, cela peut prendre quelques instants.",
  "payment.pending_refresh": "Revérifier maintenant",
  "payment.failed_title": "Paiement non abouti",
  "payment.failed_desc": "Le paiement n'a pas pu être confirmé. Si vous avez été débité, contactez le support — aucun montant n'est prélevé sur un paiement échoué.",
  "payment.missing_id": "Aucune référence de paiement fournie. Vérifiez le lien depuis lequel vous avez été redirigé.",
  "payment.back_home": "Retour à l'accueil",
  "payment.view_requests": "Voir mes demandes",
  "payment.view_dashboard": "Aller au tableau de bord",

  // Modale de paiement (dashboard)
  "payment.modal_title": "Paiement sécurisé via Moneroo",
  "payment.modal_desc": "Vous allez être redirigé vers Moneroo pour compléter le paiement.",
  "payment.modal_starting": "Redirection en cours...",
  "payment.modal_error": "Impossible d'initialiser le paiement. Veuillez réessayer.",
  "payment.modal_cancel": "Annuler",

  // File upload component
  "file_upload.uploading": "Téléchargement...",
  "file_upload.uploaded": "Fichier uploadé",
  "file_upload.remove": "Supprimer",
  "file_upload.click_or_drag": "Cliquez pour télécharger ou glissez-déposez",
  "file_upload.hint": "Vidéo (max {{video}} Mo), image ou document PDF/Word (max {{doc}} Mo)",
  "file_upload.failed": "Échec du téléchargement"
};

export default common;
